// extracted by mini-css-extract-plugin
export default {"radio":"usergrademodel_radio__gvhkB","star":"usergrademodel_star__Yp5CP"};